import React from "react";
import SelectCheckbox from "../../../../shared/select-checkbox";
import { DRAFT_STATUS } from "../../../../utils/constants/draft-status";

interface IDraftFilters {
  selectedStatus?: { value: string; label: string },
  onClickFilter: (
    value: { value: string; label: string },
    type?: string
  ) => void;
}

const DraftFilters = ({ selectedStatus, onClickFilter }: IDraftFilters) => (
  <div>
    <div className="grid grid-cols-4 gap-4">
      <SelectCheckbox
        name="Status"
        dataQa={"status-filter"}
        placeholder={""}
        options={DRAFT_STATUS || []}
        selectStyle={{
          backgroundColor: "#ffffffa4",
          borderRadius: "4px",
          minWidth: 200,
        }}
        onChangeSelectedOption={onClickFilter}
        selectedOption={selectedStatus}
        uniqueName={"status"}
      />
    </div>
  </div>
);

export default DraftFilters;
